import { ChangeDetectorRef, Component, OnInit, signal, ViewChild, ViewEncapsulation } from '@angular/core'
import { languageContent } from '../../common/json/sign-up-content'
import { signUpNewContent } from '../../common/json/sign-up-new-content'
import { UserInputService } from 'src/app/common/api/services/user-input.service'
import { StepValidationService } from 'src/app/common/api/services/step-validation.service'
import { PersonalDetailsComponent } from '../Registration-Pages/personal-details/personal-details.component'
import { AcademicDetailsComponent } from '../Registration-Pages/academic-details/academic-details.component'
import { EnglishProficiencyComponent } from '../Registration-Pages/english-proficiency/english-proficiency.component'
import { ReviewDetailsComponent } from '../Registration-Pages/review-details/review-details.component'
import { Router } from '@angular/router'
import { ViewportScroller, NgClass } from '@angular/common'
import { GtmImplementation } from 'src/app/common/api/services/gtmImplementation'
import { HeaderComponent } from '../../common/component/header/header.component';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [HeaderComponent, NgClass, PersonalDetailsComponent, AcademicDetailsComponent, EnglishProficiencyComponent, ReviewDetailsComponent]
})
export class SignUpComponent implements OnInit {
  currentNumber: number = 1
  showLoader = signal(false)
  officeDetails: any
  selectedLanguage: any
  formHeading: any
  numberOfQuestions: any
  isExistingUser: any
  countryCode: any
  messageBoxopen: boolean = true
  defaultLanguage = 'EN'
  private pendingTargetStep: number = 0
  highestCompletedStep: number = 0
  existingUserMessageText: any
  personalDetailsText: any
  academicDetailsText: any
  englishProficiencyText: any
  reviewDetailsText: any
  @ViewChild(PersonalDetailsComponent) PersonalDetailsComponent!: PersonalDetailsComponent
  @ViewChild(AcademicDetailsComponent) AcademicDetailsComponent!: AcademicDetailsComponent
  @ViewChild(EnglishProficiencyComponent) EnglishProficiencyComponent!: EnglishProficiencyComponent
  @ViewChild(ReviewDetailsComponent) reviewDetailsComponent!: ReviewDetailsComponent

  constructor (
    public userInputService: UserInputService,
    public route: Router,
    public viewPortScroller: ViewportScroller,
    public gtmImplementation: GtmImplementation,
    private cdr: ChangeDetectorRef,
    private stepValidationService: StepValidationService
  ) {}

  ngOnInit (): void {
    this.viewPortScroller.scrollToPosition([0, 0])
    const sfResponse: any = localStorage.getItem('sfResponse')
    this.officeDetails = JSON.parse(sfResponse)
    this.countryCode = this.officeDetails?.wir_country_code
    this.isExistingUser = localStorage.getItem('isExistingUser') ? localStorage.getItem('isExistingUser') : 'false'
    if (this.isExistingUser === 'true') {
      this.highestCompletedStep = 3
    }
    this.selectedLanguage = localStorage.getItem('languageSelected') ? localStorage.getItem('languageSelected') : 'EN'
    this.getLanguageContent(this.selectedLanguage)
    if (this.selectedLanguage === 'EN') {
      this.formHeading = languageContent[this.selectedLanguage]?.registrationFormHeading
      this.numberOfQuestions = languageContent[this.selectedLanguage]?.numberOfQuestionsText
    } else {
      this.formHeading = languageContent[this.countryCode + '_' + this.selectedLanguage]?.registrationFormHeading
      this.numberOfQuestions = languageContent[this.countryCode + '_' + this.selectedLanguage]?.numberOfQuestionsText
    }
  }

  getLanguageContent (language: any): any {
    const key = language === 'EN' ? language : this.countryCode + '_' + language
    this.existingUserMessageText = signUpNewContent[key]?.existingUserMessage
    this.personalDetailsText = signUpNewContent[key]?.personalDetails
    this.academicDetailsText = signUpNewContent[key]?.academicDetails
    this.englishProficiencyText = signUpNewContent[key]?.englishProficiency
    this.reviewDetailsText = signUpNewContent[key]?.reviewDetails
  }

  selectedComponent (number: number): void {
    this.currentNumber = number
  }

  /**
   * Called from review-details when submit is clicked.
   * Uses StepValidationService to find the first invalid step instantly
   * (no rendering needed), then navigates there and triggers validation UI.
   */
  navigateAndValidate (step: number): void {
    const firstInvalidStep = this.stepValidationService.getFirstInvalidStep()

    if (firstInvalidStep === 0) {
      // All steps valid — proceed with submission
      this.reviewDetailsComponent?.submitRegistrationForm()
      return
    }

    if (firstInvalidStep === -1) {
      // Questions not loaded — navigate to step 1
      this.currentNumber = 1
      return
    }

    // Navigate to the invalid step and trigger validation display
    this.currentNumber = firstInvalidStep
    this.cdr.detectChanges()
    this.triggerValidationOnCurrentStep(firstInvalidStep)
  }

  /**
   * After navigating to the invalid step, waits for the component to render
   * then triggers its validation to show error messages.
   */
  private triggerValidationOnCurrentStep (step: number): void {
    this.waitForStepComponent(step, 0)
  }

  private waitForStepComponent (step: number, attempts: number): void {
    if (attempts >= 25) return

    /* istanbul ignore next */
    setTimeout(() => {
      let component: any = null
      let formName: string = ''
      switch (step) {
        case 1: component = this.PersonalDetailsComponent; formName = 'personalDetailsForm'; break
        case 2: component = this.AcademicDetailsComponent; formName = 'academicDetailsForm'; break
        case 3: component = this.EnglishProficiencyComponent; formName = 'englishProficiencyDetailsForm'; break
      }

      if (!component) {
        this.waitForStepComponent(step, attempts + 1)
        return
      }

      const form = component[formName]
      const isLoading = component.showLoader() || component.showEngDetailsLoader?.() || component.isRefDataLoading
      if (!form || Object.keys(form.controls).length === 0 || isLoading) {
        this.waitForStepComponent(step, attempts + 1)
        return
      }

      // Component is ready — show validation errors without triggering nextClicked
      setTimeout(() => {
        // Set submitted flag to show error messages in template
        component.submitted = true

        // Ensure validators are set correctly
        if (component.updateFormValidation) {
          component.updateFormValidation()
        }
        if (component.ensureHiddenFieldsHaveNoValidation) {
          component.ensureHiddenFieldsHaveNoValidation()
        }

        // Mark all controls as touched to trigger validation display
        const currentForm = component[formName]
        if (currentForm) {
          currentForm.markAllAsTouched()
        }

        this.cdr.detectChanges()

        // Scroll to first invalid field and focus it
        setTimeout(() => {
          const invalidControl = document.querySelector(
            'form .ng-invalid:not(form), form .reg-err'
          ) as HTMLElement
          if (invalidControl) {
            invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' })
            setTimeout(() => {
              const elementToFocus =
                invalidControl.querySelector('input, [type="checkbox"], mat-select') ||
                invalidControl
              ;(elementToFocus as HTMLElement).focus()
            }, 300)
          }
        }, 200)
      }, 800)
    }, 200)
  }

  private readonly STEP_NAMES: { [key: number]: string } = {
    1: 'personal_details',
    2: 'academic_details',
    3: 'english_proficiency',
    4: 'review_details'
  }

  private trackStepperBack (fromStep: number, toStep: number): void {
    for (let step = fromStep - 1; step >= toStep; step--) {
      const pageName = this.STEP_NAMES[step]
      if (pageName) {
        this.gtmImplementation.pageView(pageName, 'signed_in_user', 'user_registration')
      }
    }
    this.gtmImplementation.skipNextPageView = true
  }

  clickedReview (number: number): void {
    if (number === this.currentNumber) return
    this.pendingExistingUserTarget = 0

    // Allow navigating backward freely
    if (number < this.currentNumber) {
      this.selectedComponent(number)
      return
    }

    // Forward navigation: validate current step first
    this.pendingTargetStep = number
    switch (this.currentNumber) {
      case 1: this.triggerNextFromPersonalDetails(); break
      case 2: this.triggerNextFromAcademicDetails(); break
      case 3: this.triggerNextFromEnglishProficiency(); break
      default: this.selectedComponent(number)
    }
  }

  private pendingExistingUserTarget: number = 0

  private handleStepNext (defaultStep: number): void {
    if (this.pendingTargetStep > 0) {
      const target = this.pendingTargetStep
      this.pendingTargetStep = 0

      // If jumping more than one step, check intermediate steps for validity
      if (target > defaultStep) {
        const firstInvalidStep = this.stepValidationService.getFirstInvalidStep()
        console.log('[SignUp] handleStepNext: defaultStep=', defaultStep, 'target=', target, 'firstInvalidStep=', firstInvalidStep)
        if (firstInvalidStep === -1) {
          // Questions not loaded — go to next step only
          this.currentNumber = defaultStep
          return
        }
        if (firstInvalidStep > 0 && firstInvalidStep < target) {
          // For existing users, store the target to navigate after data loads
          if (this.isExistingUser === 'true') {
            this.pendingExistingUserTarget = target
          }
          // A step before the target is invalid — navigate there and show errors
          this.currentNumber = firstInvalidStep
          this.cdr.detectChanges()
          this.triggerValidationOnCurrentStep(firstInvalidStep)
          return
        }
      }

      // All intermediate steps valid (or jumping to immediate next) — go to target
      this.currentNumber = target
    } else {
      this.currentNumber = defaultStep
    }
  }

  onAcademicDataLoaded (): void {
    if (this.pendingExistingUserTarget > 0 && this.isExistingUser === 'true') {
      const target = this.pendingExistingUserTarget
      this.pendingExistingUserTarget = 0
      // Re-validate now that data is loaded
      const firstInvalidStep = this.stepValidationService.getFirstInvalidStep()
      if (firstInvalidStep > 0 && firstInvalidStep < target) {
        this.currentNumber = firstInvalidStep
        this.cdr.detectChanges()
        this.triggerValidationOnCurrentStep(firstInvalidStep)
      } else {
        this.currentNumber = target
      }
    }
  }

  private navigateBack (step: number): void {
    this.currentNumber = step
  }

  onPersonalDetailsNext (): void { this.highestCompletedStep = Math.max(this.highestCompletedStep, 1); this.handleStepNext(2) }
  onAcademicDetailsNext (): void { this.highestCompletedStep = Math.max(this.highestCompletedStep, 2); this.handleStepNext(3) }
  onEnglishProficiencyNext (): void { this.highestCompletedStep = Math.max(this.highestCompletedStep, 3); this.handleStepNext(4) }

  onAcademicDetailsBack (): void { this.navigateBack(1) }
  onEnglishProficiencyBack (): void { this.navigateBack(2) }
  onReviewDetailsBack (): any { this.navigateBack(3) }

  triggerNextFromPersonalDetails (): void { this.PersonalDetailsComponent.nextButton() }
  triggerNextFromAcademicDetails (): void { this.AcademicDetailsComponent.nextButton() }
  triggerNextFromEnglishProficiency (): void { this.EnglishProficiencyComponent.nextButton() }

  messageBox (): any { this.messageBoxopen = false }

  onExistingUserChecked (isExisting: boolean): void {
    this.isExistingUser = isExisting ? 'true' : 'false'
    if (isExisting) {
      // Existing user has pre-populated data — allow free navigation between all steps
      this.highestCompletedStep = 3
    }
  }
}
